import { Form, Input, InputNumber, Select } from "antd";
import { ContainerModal, formStyle, TextModal } from "../styles";
import { layout } from "../../ViewGerenciarPropriedadeUsuario/constant/layout";
import { TitleModal } from "../../ViewGerenciarPropriedadeUsuario/styles";
import { Cota } from "../../../interfaces/Cota";
import { CotaUsuario } from "../../../interfaces/CotaUsuario";
import { Dispatch, SetStateAction } from "react";

const diasDaSemana = [
  //Array de Opções usadas no SELECT de dias da semana
  { id: 1, label: "Segunda-Feira", value: "SEGUNDA" },
  { id: 2, label: "Terça-Feira", value: "TERCA" },
  { id: 3, label: "Quarta-Feira", value: "QUARTA" },
  { id: 4, label: "Quinta-Feira", value: "QUINTA" },
  { id: 5, label: "Sexta-Feira", value: "SEXTA" },
  { id: 6, label: "Sábado", value: "SABADO" },
  { id: 7, label: "Domingo", value: "DOMINGO" },
];
interface FormConfiguracaoPropriedadeProps {
  empreendimentoSistema: boolean;
  cotas: Cota[];
  setDadosCota: Dispatch<SetStateAction<Cota>>;
  setDadosCotaUsuario: Dispatch<SetStateAction<CotaUsuario>>;
}

export default function FormConfiguracaoPropriedade({
  empreendimentoSistema,
  cotas,
  setDadosCota,
  setDadosCotaUsuario,
}: FormConfiguracaoPropriedadeProps) {
  const [formMaisInfoCota] = Form.useForm();
  const [formMaisInfoCotaUsuario] = Form.useForm();

  const configuracaoPropriedadeChange = (
    changedValues: Partial<any>,
    allValues: Cota & CotaUsuario
  ) => {
    const cota = {
      numeroCota: allValues.numeroCota,
      qtdSemanas: allValues.qtdSemanas,
      diaDaSemanaInicio: allValues.diaDaSemanaInicio,
    };
    const cotaUsuario = {
      cotaId: allValues.numeroCota,
      checked: 0, // or set to a number value from allValues if available
    };

    setDadosCota({
      ...cota,
    });
    setDadosCotaUsuario({
      ...cotaUsuario,
    });
  };

  return (
    <>
      <ContainerModal>
        <>
          {" "}
          <TitleModal>Configuração de Propriedadade</TitleModal>
          <Form
            {...layout}
            name="cota"
            form={formMaisInfoCota}
            style={formStyle}
            onValuesChange={(changedValues, allValues) =>
              configuracaoPropriedadeChange(changedValues, allValues)
            }
          >
            <TextModal>Mais Info Cota</TextModal>
            <Form.Item
              name="numeroCota"
              label="Número da cota"
              initialValue={!empreendimentoSistema ? 1 : undefined}
              className="formItems"
            >
              {empreendimentoSistema ? (
                <Select placeholder="Cota">
                  {cotas.map((cota: Cota) => (
                    <Select.Option key={cota.id} value={cota.id}>
                      {cota.numeroCota}
                    </Select.Option>
                  ))}
                </Select>
              ) : (
                <Input type="number" placeholder="Cota" readOnly />
              )}
            </Form.Item>

            <Form.Item
              name={["qtdSemanas"]}
              label="Semanas por ano"
              className="formItems"
            >
              <InputNumber
                max={4}
                min={0}
                placeholder="Quantas semanas tem direito por ano"
              />
            </Form.Item>
            <Form.Item
              name={["diaDaSemanaInicio"]}
              label="Dia Da Semana"
              className="formItems"
            >
              <Select placeholder="Selecione o dia da semana">
                {diasDaSemana.map((dias) => (
                  <Select.Option key={dias.id} value={dias.value}>
                    {dias.label}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Form>
          <Form {...layout} form={formMaisInfoCotaUsuario} style={formStyle}>
            <TextModal> Prioridade</TextModal>
            <Form.Item
              name="prioridade"
              label="Prioridade"
              className="formItems"
            >
              <Input placeholder="Prioridade" />
            </Form.Item>
          </Form>
        </>
      </ContainerModal>
    </>
  );
}
